<!-- Hero Start -->
<section class="cover-user bg-white" style="position: absolute;top: 0; width: 100%;z-index: 1030;">
    <div class="container-fluid px-0">
        <div class="row g-0 position-relative">
            <div class="col-lg-4 cover-my-30 order-2">
                <div class="cover-user-img d-flex align-items-center">
                    <div class="row login-row">
                        <div class="col-12">
                            <div class="d-flex flex-column auth-hero">
                                <div class="title-heading">
                                    <div class="card login-page border-0" style="z-index: 1">
                                        <div class="card-body p-0">
                                            <form class="login-form">
                                                <div class="mt-md-5 text-center">
                                                    <img [src]=this.companyParamsService.getLogo() />
                                                </div>
                                                <div>
                                                    <h5 class="card-title"
                                                        [style]="{'color':'#'+this.companyParamsService.getMainColor()+' !important'}">
                                                        Login</h5>
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class="mb-3">
                                                                <label class="form-label">Your Email <span
                                                                        class="text-danger">*</span></label>
                                                                <input type="email" #email
                                                                    class="form-control" name="email" required="">
                                                            </div>
                                                        </div><!--end col-->

                                                        <div class="col-lg-12">
                                                            <div class="mb-3">
                                                                <label class="form-label">Password <span
                                                                        class="text-dangerj">*</span></label>
                                                                <input type="password" #password class="form-control" required="">
                                                            </div>
                                                        </div><!--end col-->

                                                        <!--<div class="colj-lg-12">
                                                            <div class="d-flex justify-content-between">
                                                                <div class="mb-3">
                                                                    <div class="form-check">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            value="" id="flexCheckDefault">
                                                                        <label class="form-check-label"
                                                                            for="flexCheckDefault">Remember me</label>
                                                                    </div>
                                                                </div>
                                                                <p class="forgot-pass mb-0"><a
                                                                        href="cover-forgot-password.html"
                                                                        class="text-dark fw-semibold">Forgot password ?</a>
                                                                </p>
                                                            </div>
                                                        </div>--><!--end col-->

                                                        <div class="col-lg-12 mb-0">
                                                            <div class="d-grid">
                                                                <a class="btn btn-primary"
                                                                    (click)="backToPreviousPage(email.value, password.value)"
                                                                    [style]="{'background-color':'#'+this.companyParamsService.getSecundaryColor()+' !important'}">Sign
                                                                    in</a>
                                                            </div>
                                                        </div><!--end col-->
                                                        <div class="col-lg-12 mb-0">
                                                            <p class="text-danger">{{errorMessage}}</p>
                                                        </div>
                                                    </div>


                                                    <!--<div class="col-12">
                                                        <p class="mb-0 mt-3"><span class="text-dark me-2">Don't have an
                                                                account ?</span> <a href="cover-signup.html"
                                                                class="text-dark fw-semibold">Sign Up</a></p>
                                                    </div>--><!--end col-->

                                                </div><!--end row-->
                                                <div>
                                                    <div class="d-grid text-center">
                                                        <img style="border: 0px;"
                                                            src="assets/images/powered-by-galavail-sq.svg"
                                                            alt="logo-galavail">
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!--end col-->
                    </div><!--end row-->
                </div> <!-- end about detail -->
            </div> <!-- end col -->

            <div class="col-lg-8 offset-lg-4 padding-less img order-1"
            [style.background-image]="'url('+urlImage+')'"
                data-jarallax='{"speed": 0.5}'></div><!-- end col -->
        </div><!--end row-->
    </div><!--end container fluid-->
</section><!--end section-->